import type { AppealsState } from 'Store/appeals/types';

const initialState: AppealsState = {
  modalFYIviewedAt: 0, // persist
  banPolicy: null,
};

export default initialState;
